import React from 'react';
import './HeaderBanner.css';


const HeaderBanner = ({title,colored,isHome}) => {
  
  
  return (
    <section className="h-[70vh] header-img grid items-center">
      <div className="grid grid-cols-1 lg:grid-cols-5 h-full">
        {/* Text Content */}
        <div className='col-span-1  lg:col-start-2 lg:col-span-3 p-4 lg:p-2 grid justify-items-start items-center gap-4 lg:gap-6 h-full'>
        <div className="">
          <h1 className="lg:text-4xl text-white font-bold text-center">
            {title } <br /><>{colored!==""?<span className='text-[#FFDF00]'>{colored}</span>:<></>}</>
          </h1>
          {isHome && <p className="text-white font-semibold text-left">
            Zone humide, Soliman Tunisie
          </p>}
        </div>
        </div>
        {/* <button >Découvrir le projet</button> */}
        
      </div>
    </section>
  );
}

export default HeaderBanner;
